<template>
  <span class="ml-3" v-if="model.fields.filter(x => x.sortable).length > 1">
    <b-button size="sm" variant="primary" v-b-modal.modalMultiSort :disabled="disabled">
      <i class="fa fa-sort"></i>
    </b-button>

    <b-modal id="modalMultiSort" ref="modalMultiSort" hide-footer @show="init">
      <template #modal-title><translate>Multi Field Sort</translate></template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <b-form @submit.prevent="emitSorts" v-if="sorts.length">
        <div class="mb-3">
          <b-button size="sm" variant="dark" @click="addLevel" :disabled="options.findIndex(x => x.disabled === false) === -1">
            <i class="fa fa-plus"></i>
            <translate>Add Level</translate>
          </b-button>
          <b-button size="sm" variant="dark" @click="deleteLevel(null)" :disabled="sorts.length <= 2">
            <i class="fa fa-minus"></i>
            <translate>Delete Level</translate>
          </b-button>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th>
                <translate>Column</translate>
              </th>
              <th>
                <translate>Direction</translate>
              </th>
              <th></th>
            </tr>
          </thead>
          <draggable v-model="sorts" tag="tbody">
            <tr v-for="(sort, i) of sorts" :key="sort.sortBy">
              <td>
                <font-awesome-icon icon="grip-horizontal" class="handler" />
              </td>
              <td>
                <translate v-show="i === 0">Sort by</translate>
                <translate v-show="i !== 0">Then by</translate>
              </td>
              <td>
                <b-select v-model="sorts[i].sortBy" :options="optionsComputed" class="form-control"></b-select>
              </td>
              <td>
                <b-select v-model="sorts[i].sortDirection" :options="[{text: $gettext('Ascending'), value: 'asc'}, {text: $gettext('Descending'), value: 'desc'}]" class="form-control"></b-select>
              </td>
              <td>
                <b-button size="sm" variant="danger" @click.stop="deleteLevel(i)" :disabled="sorts.length <= 2">
                  <font-awesome-icon icon="trash-alt" size="2x" style="font-size: 16px;vertical-align: middle" />
                </b-button>
              </td>
            </tr>
          </draggable>
        </table>
        <div class="mb-3">
          <b-button size="sm" variant="success" @click="emitSorts">
            <translate>Apply</translate>
          </b-button>
          <b-button size="sm" variant="danger" @click="$refs.modalMultiSort.hide()">
            <translate>Close</translate>
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </span>
</template>

<script>
import Draggable from 'vuedraggable'

export default {
  name: 'ApiListMultiSort',
  components: {
    Draggable
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    previousSorts: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      sorts: [],
      options: []
    }
  },
  computed: {
    optionsComputed() {
      return this.options.map(x => {
        if (this.sorts.map(y => y.sortBy).indexOf(x.value) !== -1) {
          x.disabled = true
        } else {
          x.disabled = false
        }
        return x
      })
    }
  },
  methods: {
    init() {
      this.sorts = []
      this.options = this.model.fields.filter(x => x.sortable).map(x => {
        return {
          text: x.label,
          value: x.key,
          disabled: false
        }
      })
      if (this.previousSorts?.length) {
        this.sorts = this.previousSorts
      } else {
        for (let i = 0; i < 2; i++) {
          this.sorts.push({
            sortBy: this.options[i].value,
            sortDirection: 'desc'
          })
        }
      }
    },
    addLevel() {
      this.sorts.push({
        sortBy: this.options.find(x => x.disabled === false).value,
        sortDirection: 'desc'
      })
    },
    deleteLevel(index = null) {
      if (index === null) {
        this.sorts.pop()
      } else {
        this.sorts.splice(index, 1)
      }
    },
    emitSorts() {
      this.$emit('updated', this.sorts)
      this.$refs.modalMultiSort.hide()
    }
  }
}
</script>
